import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as fs from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class DownloadFileService {
  openPDF(data, reportname, Head, orientation): void {

    var doc = new jsPDF({ orientation: orientation });
    doc.setFontSize(18);
    doc.text(reportname, 11, 8);
    doc.setFontSize(11);
    doc.setTextColor(100);
    autoTable(doc, {
      head: Head,
      body: data,
      theme: 'plain',
      styles: { minCellWidth: 12, overflow: 'linebreak' },
      tableWidth: 'auto',
      didDrawCell: () => {},
    });

    const safeFilename = String(reportname).replace(/[/\\.<>:"|?*]/g, '_');
    doc.output('dataurlnewwindow');
    doc.save(safeFilename + new Date().getTime());
  }

  exportExcel(workbook, data, ReportName) {
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, ReportName);
    });
  }
}
